import React from 'react';
import { SlideContainer } from '../SlideContainer';
import { FadeInStagger, FadeIn } from '../FadeIn';
export const Slide04Proof = () => {
  const modules = [{
    name: 'Reflection',
    desc: 'Synthesize readings and articulate key insights before class'
  }, {
    name: 'Interactive Quiz',
    desc: 'Voice-probed questions that test reasoning, not just recall'
  }, {
    name: 'Oral Defense',
    desc: 'Upload written work, then defend it under rigorous questioning'
  }, {
    name: 'Critical Thinking',
    desc: 'Apply a framework to a situation, discuss trade-offs, ground in real-world examples'
  }, {
    name: 'Case Discussion',
    desc: 'Analyze a business case, get probed on reasoning and recommendations'
  }, {
    name: 'Keynote',
    desc: 'Present and defend a capstone presentation against a rubric'
  }];
  return <SlideContainer data-id="element-83">
      <FadeInStagger data-id="element-84">
        <FadeIn data-id="element-85">
          <div className="mb-12" data-id="element-86">
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-white mb-4" data-id="element-87">
              A full semester in production
            </h2>
            <h3 className="text-xl md:text-2xl text-white/60 font-medium" data-id="element-88">
              Live at University of Toronto and Texas A&M with 200+ students
            </h3>
          </div>
        </FadeIn>

        <FadeIn data-id="element-89">
          <p className="text-lg text-white/70 max-w-3xl mb-16 leading-relaxed" data-id="element-90">
            Six modules designed, built, and tested with real students across
            multiple cohorts. Iterating closely with faculty. The product is
            in a fundamentally different place than where it was a few months
            ago.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-91">
          {modules.map((mod, i) => <FadeIn key={i} data-id="element-92">
              <div className="flex items-start group" data-id="element-93">
                <span className="text-accent-purple/70 font-mono text-sm mt-1 mr-4 w-6 shrink-0" data-id="element-94">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div data-id="element-95">
                  <h4 className="text-lg font-medium text-white mb-1 group-hover:text-accent-purple transition-colors" data-id="element-96">
                    {mod.name}
                  </h4>
                  <p className="text-white/50 leading-relaxed" data-id="element-97">{mod.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </FadeInStagger>
    </SlideContainer>;
};